module.exports = __webpack_public_path__ + "img/partner-dibimbing.1d40c8b2.png";